import { axios, AxiosResponse } from '~/modules'
import { IVaccine, IVaccineParams } from '~/interfaces'

const { REACT_APP_API_HSTORY_URL: hstoryAPI } = process.env

export const fetchVaccines = async (params: IVaccineParams): Promise<IVaccine[]> => {
  const { patientId, name, startDate, endDate } = params
  const response = await axios.get(`${hstoryAPI}/patients/${patientId}/vaccines`, {
    params: {
      name,
      startDate,
      endDate
    }
  })
  const { data }: AxiosResponse<IVaccine[]> = response
  return data
}
